import styled from "styled-components";

export const StyledTicketPoolSummaryList = styled.ul`
  list-style: none;
`;

export const StyledTicketPoolSummaryListItem = styled.li``;
